import { defineComponent, onMounted, computed } from 'vue';
import __vue_component__ from './SessionCard.vue.js';
import { useSessionStore, SessionContextID } from '../../../../store/portal/sessionStore.js';

var script = defineComponent({
    name: 'SessionManager',
    components: {
        SessionCard: __vue_component__,
    },
    setup() {
        const sessionStore = useSessionStore();
        onMounted(sessionStore.initSessions);
        const contextIDs = computed(() => Object.values(SessionContextID));
        const isSessionActive = (sessionID) => sessionID === sessionStore.activeSession;
        const getInfoBySessionID = (sessionID) => sessionStore.sessionInfoByID.getRaw(sessionID);
        const loadingSession = computed(() => sessionStore.sessionLoading);
        const isSessionInfoLoading = (sessionID) => !getInfoBySessionID(sessionID) && loadingSession.value;
        const contexts = computed(() => contextIDs.value.map((id) => sessionStore.sessionsByContext.get(id)));
        const openSession = (sessionID) => {
            if (isSessionActive(sessionID))
                return;
            sessionStore.openItinerarySession({
                itineraryID: sessionID,
            });
        };
        const deleteSession = (sessionID) => {
            sessionStore.deleteItinerarySession(sessionID);
        };
        return {
            contexts,
            deleteSession,
            getInfoBySessionID,
            isSessionInfoLoading,
            isSessionActive,
            openSession,
        };
    },
});

export { script as default };
